(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/fp/update', '../util/lodashFpConvert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/fp/update'), require('../util/lodashFpConvert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.update, global.lodashFpConvert);
    global.update = mod.exports;
  }
})(this, function (exports, _update2, _lodashFpConvert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.update = undefined;

  var _update3 = _interopRequireDefault(_update2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var convertedUpdate = (0, _lodashFpConvert.lodashFpConvert)(_update3.default);

  /**
   * Updates the value at <code>path</code> of <code>object</code> using the <code>updater</code> function.<br/>
   * The updater is invoked with <code>value</code> and <code>…args</code>.<br/>
   * Be carefull, the <code>updater</code> function must not mutate its <code>value</code> argument.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} updater The function to produce the updated value.
   * @param {...*} args The remaining args.
   * @return {Object} Returns the updated object.
   * @example <caption>Updating a prop</caption>
   * const inc = (v, i = 1) => v + i // this function increments a number with an optional value which defaults to 1
   * const object = { nested: { prop: 4 } }
   * update(object, 'nested.prop', inc) // => { nested: { prop: 5 } }
   * update(object, 'nested.prop', inc, 2) // => { nested: { prop: 6 } }
   * @see {@link https://lodash.com/docs#update|lodash.update} for more information.
   * @since 0.1.5
   */
  var update = function update(object, path, updater) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    return convertedUpdate(object, path, function (v) {
      return updater.apply(undefined, [v].concat(args));
    });
  };
  exports.update = update;
  exports.default = update;
});